import { titleCase } from "../../../helper";
import {
  BoxTab,
  BoxTabEach,
  TabHeader,
  TabSub,
} from "../../../pages/YachtClubViewDetails";

interface VisitDetailsprops {
  ownerName: string;
  mobileNumber: string;
  email: string;
  passport: string;
  homeAddress: string;
  workAddress: string;
  lrOrCap: string;
}
const OwnersDetails = ({
  ownerName,
  mobileNumber,
  email,
  passport,
  homeAddress,
  workAddress,
  lrOrCap,
}: VisitDetailsprops) => {
  return (
    <>
      <BoxTab>
        <BoxTabEach>
          <TabHeader>Name</TabHeader>
          <TabSub>{titleCase(ownerName)}</TabSub>
        </BoxTabEach>
        <BoxTabEach>
          <TabHeader>Mobile Number</TabHeader>
          <TabSub>{mobileNumber}</TabSub>
        </BoxTabEach>
        <BoxTabEach>
          <TabHeader>Email Address</TabHeader>
          <TabSub>{email}</TabSub>
        </BoxTabEach>
        <BoxTabEach>
          <TabHeader>Passport Number</TabHeader>
          <TabSub>{passport}</TabSub>
        </BoxTabEach>
        <BoxTabEach>
          <TabHeader>P.O Box & Home Address</TabHeader>
          <TabSub>{titleCase(homeAddress)}</TabSub>
        </BoxTabEach>
        <BoxTabEach>
          <TabHeader>Work Address</TabHeader>
          <TabSub>{titleCase(workAddress)}</TabSub>
        </BoxTabEach>
        <BoxTabEach>
          <TabHeader>Legal Representative or Captain</TabHeader>
          <TabSub>{titleCase(lrOrCap)}</TabSub>
        </BoxTabEach>
      </BoxTab>
    </>
  );
};

export default OwnersDetails;
